import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-window-max",
  "use": "icon-window-max-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol fill=\"#000000\" viewBox=\"0 0 36 36\" preserveAspectRatio=\"xMidYMid meet\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-window-max\">\n    <title>window-max-line</title>\n    <path d=\"M27.89,9h-20a2,2,0,0,0-2,2V25a2,2,0,0,0,2,2h20a2,2,0,0,0,2-2V11A2,2,0,0,0,27.89,9Zm-20,16V11h20V25Z\" class=\"clr-i-outline clr-i-outline-path-1\" />\n    <rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" fill-opacity=\"0\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/window-max.svg
// module id = HR+Z
// module chunks = 84